import { render, staticRenderFns } from "./HomeBackground.vue?vue&type=template&id=745e476b&"
import script from "./HomeBackground.vue?vue&type=script&lang=js&"
export * from "./HomeBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports